import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Helmet from "react-helmet";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<>
		<Helmet>
			<title>CareerSahi - India’s First School, College & Career Platform</title>
			<link rel="icon" type="image/x-icon" href="./favicon.ico" />
		</Helmet>
		<App />
	</>
);
